import {configureStore, getDefaultMiddleware} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import {reduxBatch} from "@manaflair/redux-batch";
import {persistStore} from "redux-persist";
import {rootReducer, rootSaga} from "./rootReducer";
import {oversightApi} from "./apiSlice";

const sagaMiddleware = createSagaMiddleware();
const middleware = [
    ...getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        thunk: true
    }),
    sagaMiddleware,
    oversightApi.middleware
];

const store = configureStore({
    reducer: rootReducer,
    middleware,
    devTools: process.env.NODE_ENV !== "production",
    enhancers: [reduxBatch]
});

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);


/**
 * Confirm if user have active session, else clear user data for re-authentication
 */
const session = JSON.parse(localStorage.getItem('persist:oversight-dashboard'))?.session;

if (session && JSON.parse(session)?.expire < (new Date()).getTime()) {
    persistor.purge();
}


sagaMiddleware.run(rootSaga);

export default store;
